import { combineReducers } from 'redux';
import account from './login';
import incident from './incident';
import checklists from './checklist';
import task from  './task';
import risks from "./risk";
import documents from './document';

export default combineReducers({
    account,
    incident,
    checklists,
    task,
    risks,
    documents,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js